import { render, staticRenderFns } from "./Overview.vue?vue&type=template&id=ba33428e&"
import script from "./Overview.vue?vue&type=script&lang=js&"
export * from "./Overview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba33428e')) {
      api.createRecord('ba33428e', component.options)
    } else {
      api.reload('ba33428e', component.options)
    }
    module.hot.accept("./Overview.vue?vue&type=template&id=ba33428e&", function () {
      api.rerender('ba33428e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/DmVisualizer/Components/Overview.vue"
export default component.exports